export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const ADD_ACCOUNT_SUCCESS = "ADD_ACCOUNT_SUCCESS";
export const ADD_ACCOUNT_FAILED = "ADD_ACCOUNT_FAILED";

export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILED = "FETCH_USER_FAILED";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILED = "DELETE_USER_FAILED";

export const FETCH_USERS = "FETCH_USERS";
export const FETCH_USERS_SUCCES = "FETCH_USERS_SUCCES";
export const FETCH_USERS_FAILED = "FETCH_USERS_FAILED";

export const CHECK_EMAIL = "CHECK_EMAIL";
export const CHECK_EMAIL_FAILED = "CHECK_EMAIL_FAILED";
export const CHECK_EMAIL_SUCCESS = "CHECK_EMAIL_SUCCESS";

export const ADD_ROLED_USER = "ADD_ROLED_USER";
export const ADD_ROLED_USER_SUCCESS = "ADD_ROLED_USER_SUCCESS";
export const ADD_ROLED_USER_FAILED = "ADD_ROLED_USER_FAILED";

export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_FAILED = "SIGN_IN_FAILED";

export const SIGNED_OUT = "SIGNED_OUT";

export const EDIT_USER_INFO = "EDIT_USER_INFO";

export const FETCH_FORGOT_PASSWORD = "FETCH_FORGOT_PASSWORD";
export const FETCH_FORGOT_PASSWORD_SUCCESS = "FETCH_FORGOT_PASSWORD_SUCCESS";
export const FETCH_FORGOT_PASSWORD_FAILED = "FETCH_FORGOT_PASSWORD_FAILED";

export const SEND_EMAIL = "SEND_EMAIL";
export const SEND_EMAIL_SUCCES = "SEND_EMAIL_SUCCES";
export const SEND_EMAIL_FAILED = "SEND_EMAIL_FAILED";

export const UPDATE_ROLE = "UPDATE_ROLE";
export const UPDATE_ROLE_FAILED = "UPDATE_ROLE_FAILED";
export const UPDATE_ROLE_SUCCES = "UPDATE_ROLE_SUCCES";



// WEBPACK FOOTER //
// ./src/modules/user/constants.js